import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserRoleService } from '../auth/user-role.service';
import { dashboardEntryRoute } from '@app/domain/models/dashboard-lines.model';

/**
 * Acceso al módulo E-commerce (`/e-commerce` y todo lo que cuelga de él): gestor
 * PAYMENTS en la sesión (lo entrega el verify) y el módulo encendido en el AMBIENTE
 * (`environment.featureFlags.ecommerce`, kill-switch del deploy). Decisión del humano
 * 2026-10-07: NO depende del rol SPEI de la entidad activa ni de las `features` del
 * tenant — el tenant es solo rebranding (CLAUDE.md, regla 5 del acoplamiento).
 *
 * Reemplaza a `featureGuard` en esta ruta: con el flag del TENANT apagado, `featureGuard`
 * mandaba a `/dashboard` y `gestorGuard` de vuelta a la Pasarela de Pagos — el ciclo
 * de la pregunta P5. Sin flag de tenant ese ciclo ya no existe.
 *
 * Sin acceso redirige a la entrada de dashboard del usuario (`dashboardEntryRoute`, la
 * regla ÚNICA de la feature 108): nunca `/login` para una sesión válida (sin líneas ⇒
 * `/products`). Nunca a `/e-commerce/dashboard`: sin `canUseEcommerce()` no hay línea
 * `payments`, así que la regla no la propone.
 */
export const ecommerceGuard: CanActivateFn = () => {
  const userRole = inject(UserRoleService);
  if (userRole.canUseEcommerce()) return true;

  return inject(Router).createUrlTree([dashboardEntryRoute(userRole.getBusinessLines())]);
};
